import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertAudioCommand from './insertaudiocommand';
import {
  toWidget,
  viewToModelPositionOutsideModelElement
} from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

import { removeDefaultHtmlSpanAttributes } from '../../src/utils/subtemplateutils';
export default class InsertAudioUI extends Plugin {
  static get requires() {
    return [Widget];
  }

  init() {
    this._defineSchema();
    this._defineConverters();
    this.editor.commands.add('insertaudio', new InsertAudioCommand(this.editor));
    this.editor.editing.mapper.on(
      'viewToModelPosition',
      viewToModelPositionOutsideModelElement(this.editor.model, viewElement => viewElement.hasClass('inlineaudio'))
    );

    this.listenTo(this.editor.editing.view.document, 'click', () => {
      const selectedElement = this.editor.model.document.selection.getSelectedElement();
      if (selectedElement?.name === 'inlineaudio') {
        const childNode = selectedElement._children._nodes[0];
        const subChildNode = childNode._children._nodes[0];
        if (childNode.name === 'audio' && subChildNode.name === 'source') {
          const audioObj = {
            mediaName: 'audio', 'dataTenantId': subChildNode._attrs.get('data-tenant-id'), 'name': subChildNode._attrs.get('data-node-name'),
            'mediaId': childNode._attrs.get('id'), 'title': subChildNode._attrs.get('title'), 'desc': subChildNode._attrs.get('data-description'), 'credLine': subChildNode._attrs.get('data-credit-line')
          }
          this.editor.fire('mediaselected', audioObj);
        }
      }
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.register('inlineaudio', {
      allowWhere: '$text',
      isInline: true,
      isObject: true,
      allowAttributesOf: '$text',
      allowAttributes: ['class'],
      allowContentOf: '$root'
    });
  }

  _defineConverters() {
    const conversion = this.editor.conversion;
    this.editor.model.schema.addAttributeCheck(context => {
      if (context.endsWith('inlineaudio')) {
        return true;
      }
    });

    conversion.for('upcast').elementToElement({
      view: {
        name: 'span',
        classes: ['ck-span']
      },
      model: (viewElement, { writer: modelWriter }) => {
        return modelWriter.createElement('inlineaudio', viewElement.getAttributes());
      }
    });

    conversion.for('dataDowncast').elementToElement({
      model: 'inlineaudio',
      view: {
        name: 'span',
        classes: ['ck-span']
      }
    });

    conversion.for('editingDowncast').elementToElement({
      model: 'inlineaudio',
      view: (modelItem, { writer: viewWriter }) => {
        removeDefaultHtmlSpanAttributes(modelItem, this.editor);
        const audio = viewWriter.createContainerElement('span', { class: 'ck-span' });
        return toWidget(audio, viewWriter, { hasSelectionHandle: true });
      }
    });
  }
}